// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hzmxwfqrsuzlhgfzwtba.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh6bXh3ZnFyc3V6bGhnZnp3dGJhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMzNTg5ODMsImV4cCI6MjA1ODkzNDk4M30.5oxTogQvTveTLfGFoBR6FG9PiNAjRXAsHQQhEKNmw04";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);